{
  "slug": "does-sleep-affect-iq",
  "title": "Le sommeil affecte-t-il les performances du test de QI?",
  "description": "Un mauvais sommeil peut affecter l'attention, la mémoire, la vitesse et la cohérence.",
  "category": "Questions de QI répondues",
  "sections": [
    {
      "heading": "Réponse courte",
      "paragraphs": [
        "Un mauvais sommeil peut affecter l'attention, la mémoire, la vitesse et la cohérence."
      ]
    },
    {
      "heading": "Ce qui l'affecte",
      "paragraphs": [
        "La qualité du test, l’âge, la santé, la langue, l’éducation, la motivation, l’environnement et le but sont tous importants.",
        "Un effet moyen d'étude ne peut pas prédire exactement une personne."
      ]
    },
    {
      "heading": "Orientation",
      "paragraphs": [
        "Utilisez un sommeil adéquat, des conditions calmes, des accommodements et un instrument approprié.",
        "Pour les décisions concernant les enfants, la santé, le handicap ou les enjeux importants, consultez un professionnel qualifié."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "Un sommeil médiocre peut affecter l'attention, la mémoire, la vitesse et la cohérence. 18 Juillet 2026."
}
